import { Component, Inject, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CopyFromComponent } from '../copy-from/copy-from.component';
import { IMarketingDocument } from 'src/app/core/models/masters/marketing-document.model';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { Router, ActivatedRoute } from '@angular/router';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-copy-from-popup',
  templateUrl: './copy-from-popup.component.html',
  styleUrls: ['./copy-from-popup.component.css']
})
export class CopyFromPopupComponent extends GenericListView<IMarketingDocument> {
  @ViewChild(MatTable) table!: MatTable<any>;

  local_data: any;
  documentEntry: string = ""
  selectAll: boolean = false;

  override async PopulateListViewForOnScrollPagination() {
    await super.PopulateListViewForOnScrollPagination();
    this.checkIfAllSelected();
    if (this.table) {
      this.table.renderRows();
    }
  }

  override async PopulateListViewGeneric(aUrl: string, aRequestData: any): Promise<any[]> {
    this.setListViewDataSourceOnScrollPagination = [];
    await this.PopulateListViewForOnScrollPagination();
    return this.getListViewDataSourceOnScrollPagination;
  }

  constructor(agenericRepository: GenericService<IMarketingDocument>, router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>) {
    super(agenericRepository, router);
    this.local_data = data;
    this.setListViewDataSourceURL = this.local_data.endPoint;
    this.getRequestData.IsAcending = false;
    this.setDisplayedColumnsNamesList = ['select', '#', 'docNo', 'customerName', 'docDate', 'customerCode', 'docTotal'];
    if (this.local_data.name != 'Purchase Request') {
      const defaultFilters = [
        {
          "Key": "cardCode",
          "Value": this.local_data.docEntry,
          "OperatorType": "startswith"
        },
        {
          "Key": "cardCode",
          "Value": "",
          "OperatorType": "endswith"
        },
        {
          "Key": "documentStatus",
          "Value": "O",
          "OperatorType": "contains"
        }
      ] as any;
      this.getRequestData.RequestData = defaultFilters;
      this.setFilterArrCustom = defaultFilters;
    }
    else {
      const defaultFiltersPR = [
        // {
        //   "Key": "requester",
        //   "Value": this.local_data.docEntry,
        //   "OperatorType": "startswith"
        // },
        // {
        //   "Key": "requester",
        //   "Value": "",
        //   "OperatorType": "endswith"
        // },
        {
          "Key": "documentStatus",
          "Value": "O",
          "OperatorType": "contains"
        }
      ] as any;
      this.getRequestData.RequestData = defaultFiltersPR;
      this.setFilterArrCustom = defaultFiltersPR;
    }

    this.getRequestData.SortColumn = "docEntry";
    this.PopulateListViewForOnScrollPagination();
  }

  toggleSelectAll() {
    const newVal = this.selectAll;
    this.getListViewDataSourceOnScrollPagination.forEach(row => row.selected = newVal);
  }

  checkIfAllSelected() {
    if (this.getListViewDataSourceOnScrollPagination.length === 0) {
      this.selectAll = false;
      return;
    }
    this.selectAll = this.getListViewDataSourceOnScrollPagination.every(row => row.selected);
  }

  onSelectionChange(row: any, event: MatCheckboxChange) {
    if (event.checked) {
      row.selected = true;
    }
    else {
      row.selected = false;
    }
    this.checkIfAllSelected();
  }
  
  onChooseDocument() {
    this.dialogRef.close({
      event: true,
      value: this.getListViewDataSourceOnScrollPagination.filter(i => { return i.selected == true }).
        map(i => { return { docEntry: i.docEntry, docNum: i.docNum }; })
    });
  }

}
